import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ClaimListItem from '../claim-list-item';
import { ACCOUNT, CARD, PAYMENT, REWARDS } from '../../claim-names';
import personalPath from '@starbucks-web/pattern-library/lib/icons/personal';
import mobileOrderingPath from '@starbucks-web/pattern-library/lib/icons/mobile-ordering';
import creditCardPath from '@starbucks-web/pattern-library/lib/icons/credit-card';
import starShowerPath from '@starbucks-web/pattern-library/lib/icons/star-shower';
import StarbucksRewardsTrademark from 'shared/app/components/starbucks-rewards-trademark';
import messages from './messages';
import { useSelector } from 'react-redux';
import { claimsSelector } from '../../state/selectors';

const ClaimsList = () => {
  const claims = useSelector(claimsSelector);

  if (!claims || claims.length === 0) {
    return null;
  }

  const claimItems = {
    [ACCOUNT]: {
      text: <FormattedMessage {...messages[ACCOUNT]} />,
      iconPath: personalPath,
    },
    [CARD]: {
      text: <FormattedMessage {...messages[CARD]} />,
      iconPath: mobileOrderingPath,
    },
    [PAYMENT]: {
      text: <FormattedMessage {...messages[PAYMENT]} />,
      iconPath: creditCardPath,
    },
    [REWARDS]: {
      text: (
        <FormattedMessage
          {...messages[REWARDS]}
          values={{
            starbucksRewardsTrademark: <StarbucksRewardsTrademark />,
          }}
        />
      ),
      iconPath: starShowerPath,
    },
  };

  return (
    <ul className="my3">
      {claims.map((claim, i) => (
        <ClaimListItem key={i} {...claimItems[claim]} />
      ))}
    </ul>
  );
};

ClaimsList.propTypes = {
  claims: PropTypes.arrayOf(PropTypes.oneOf([ACCOUNT, CARD, PAYMENT, REWARDS]))
    .isRequired,
};

export default ClaimsList;
